"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackWishlistButtonClick = void 0;
const enums_1 = require("../enums");
const trackAnalyticsEvent_1 = require("./trackAnalyticsEvent");
function trackWishlistButtonClick(clickUrl, clickElement) {
    (0, trackAnalyticsEvent_1.trackAnalyticsEvent)({
        category: enums_1.EventCategory.Header,
        action: enums_1.EventAction.Click,
        label: 'Wishlist',
        nonInteraction: false,
        eventData: {
            eventName: enums_1.GA4EventName.ClickNavigationItem,
            feature_category: enums_1.GA4FeatureCategory.HeaderNavigation,
            click_element: clickElement,
            click_url: clickUrl,
        },
    });
}
exports.trackWishlistButtonClick = trackWishlistButtonClick;
//# sourceMappingURL=trackWishlistButtonClick.js.map